import { tv } from "tailwind-variants";

const base = tv({
    base: "tw:font-bold tw:text-primary tw:italic tw:uppercase tw:flex tw:w-fit tw:items-start",
    variants: {
        size: {
            xs: "tw:leading-4 tw:gap-0.5",
            sm: "tw:leading-6 tw:gap-0.5",
            md: "tw:leading-10 tw:gap-0.75",
            lg: "tw:leading-16 tw:gap-1",
            xl: "tw:gap-3 tw:lg:gap-4"
        }
    },
    defaultVariants: {
        size: "md"
    }
});

const whole = tv({
    base: ["tw:text-trim-cap tw:block tw:font-gravity"],
    variants: {
        size: {
            xs: "",
            sm: "tw:text-xl",
            md: "tw:text-4xl",
            lg: "tw:text-6xl",
            xl: "tw:text-8xl tw:lg:text-[11rem]"
        }
    },
    defaultVariants: {
        size: "md"
    }
});

const decimal = tv({
    base: ["tw:text-trim-cap tw:block tw:font-gravity"],
    variants: {
        size: {
            xs: "tw:text-xs",
            sm: "tw:text-sm",
            md: "tw:text-2xl",
            lg: "tw:text-4xl",
            xl: "tw:text-5xl tw:lg:text-8xl"
        }
    },
    defaultVariants: {
        size: "md"
    }
});

export const main = Object.assign(base, {
    whole: whole,
    decimal: decimal
});
